import fetchWebApi from 'api/fetchWebApi';

const deleteTokenApiCall = async (): Promise<void> => {
  fetchWebApi('/token/invalidate', undefined, {
    method: 'delete',
  });
};

export default deleteTokenApiCall;
